import React, { useState, useEffect } from "react";
import banner from "../../images/media/banner.jpg";
import mbBanner from "../../images/media/mbBanner.png";
import BannerItem from "../../component/BannerItem/BannerItem";
import Button from "../../component/Button/Button";
import TvAds from "../../component/TvAds/TvAds";
import WOW from "wowjs";
import useWindowDimensions from "../../useWindowDimensions";
import "./style.less";
import PressRelease from "../../component/PressRelease/PressRelease";
import Events from "../../component/Events/Events";
import { Redirect } from "react-router-dom";
import loadergif from "../../images/loader.gif";
import axios from "axios";
import urldata from "../../urldata";
import Imageurldata from "../../Imageurldata";
import config from "../../config/config";
const Media = (props) => {
  const { height, width } = useWindowDimensions();
  const [tab, setTab] = useState(0);
  const [loading, setLoading] = useState(true);
  const [pressRelease, setpressRelease] = useState([]);
  const [tvAds, settvAds] = useState([]);
  const [mediaBanner, setmediaBanner] = useState([]);
  const azure_object_url = config.azure_object_url;

  useEffect(() => {
    window.scroll(0, 0);
    new WOW.WOW({
      live: false,
    }).init();
  }, []);

  useEffect(() => {
    let url = new URL(urldata + "user/getMediaData");

    axios({
      method: "get",
      url: url,
      withCredentials: true,
    })
      .then((response) => {
        const data = response.data.data;

        // Sort both arrays in ascending order by sort_order
        const sortedTvAds = sortByOrderAscending(data.tvAds || []);
        const sortedPressRelease = sortByOrderAscending(
          data.pressrelease || [],
        );

        settvAds(sortedTvAds);
        setpressRelease(sortedPressRelease);
        setmediaBanner(data.bannerData);

        setLoading(false);
      })
      .catch((error) => {
        props.history.push("/500");
      });

    // Tab routing logic
    switch (props.match.params.id) {
      case "tv-ads":
        setTab(0);
        break;
      case "press-release":
        setTab(1);
        break;
      default:
        props.history.push("/media/tv-ads");
        break;
    }
  }, [props.match.params.id]);

  // Helper to sort by sort_order (ascending: 0 → 1 → 2...)
  const sortByOrderAscending = (items) => {
    return [...items].sort((a, b) => a.sort_order - b.sort_order);
  };

  if (loading) {
    return (
      <div className="loadergifdiv">
        <img src={loadergif} className="img-fluid" />
      </div>
    );
  }

  return (
    <>
      <BannerItem
        img={azure_object_url + mediaBanner[0].imgUrl}
        imgMb={azure_object_url + mediaBanner[0].mbimgUrl}
        title={mediaBanner[0].title}
        color="white"
      />
      <div className="mediaTabContainer">
        <div
          onClick={() => props.history.push("/media/tv-ads")}
          className={tab === 0 ? "active tab" : "tab"}
        >
          TV ADS
        </div>
        <div
          onClick={() => props.history.push("/media/press-release")}
          className={tab === 1 ? "active tab" : "tab"}
        >
          PRESS RELEASE
        </div>
        {/* <div
          onClick={() => props.history.push("events")}
          className={tab === 2 ? "active tab" : "tab"}
        >
          EVENTS
        </div> */}
      </div>

      <section>{tab === 0 ? <TvAds tvAdsArr={tvAds} /> : null}</section>
      <section>
        {tab === 1 ? <PressRelease pressReleaseArr={pressRelease} /> : null}
      </section>
      {/* <section>{tab === 2 ? <Events /> : null}</section> */}
    </>
  );
};

export default Media;
